// extracted by mini-css-extract-plugin
export default {"statusActive":"ActivenessDisplay_statusActive__M3rGz","statusInactive":"ActivenessDisplay_statusInactive__xBi0a"};